import { render, staticRenderFns } from "./CongressesEdit.vue?vue&type=template&id=789f595f"
import script from "./CongressesEdit.vue?vue&type=script&lang=js"
export * from "./CongressesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports